/** An absent selection defaults to HKD; an explicit empty value opens inventory. */
export function reportCurrency(params: URLSearchParams): string | null {
  return params.has('currency') ? params.get('currency') || null : 'HKD';
}
